/* eslint-disable lingui/no-unlocalized-strings -- Backend permission and status identifiers. */
import { useConfig, isRootTenancy } from '@/shared/config';
import { usePermissions } from '@/shared/permissions';
import type { Billing } from './billing.wire';
export function billingRowAccess(
  row: Billing,
  read: boolean,
  update: boolean,
  create: boolean,
  root: boolean,
) {
  return {
    register: read && !row.registered && row.statusValue !== 'Registering',
    edit: read && !row.registered && row.statusValue !== 'Registering',
    cancel: read && ['NotRegistered', 'Registered'].includes(row.statusValue),
    email: read && row.statusValue !== 'NotRegistered',
    communication: read && update && row.statusValue === 'NotRegistered',
    comment: read && root,
    fees: read && root && create,
  };
}
export function useBillingRowAccess(row: Billing) {
  const permissions = usePermissions();
  const config = useConfig();
  return billingRowAccess(
    row,
    permissions.can('BillingAccount', 'Read'),
    permissions.can('BillingAccount', 'Update'),
    permissions.can('BillingAccount', 'Create'),
    isRootTenancy(config),
  );
}
export function billingBatchAccess(rows: readonly Billing[], read: boolean) {
  const populated = read && rows.length > 0 && rows.every((row) => !!row.bankSlip?.barCode);
  const movable =
    populated &&
    rows.every(
      (row) =>
        row.bankSlip?.statusRegisterValue?.toLowerCase() !== 'baixado' &&
        row.bankSlip?.statusSettlementValue?.toLowerCase() !== 'settlement',
    );
  const sameWallet = rows.every((row) => row.walletCode === rows[0]?.walletCode);
  return {
    batch:
      populated &&
      rows.every(
        (row) =>
          row.bankSlip?.statusRegisterValue?.toLowerCase() === 'registradocip' &&
          row.bankSlip.statusSettlementValue?.toLowerCase() !== 'settlement',
      ),
    transfer: movable && sameWallet,
    instruction: movable,
    delivery: populated && sameWallet && rows.every((row) => row.registered && !!row.bankSlip?.id),
  };
}
export function useBillingBatchAccess(rows: readonly Billing[]) {
  return billingBatchAccess(rows, usePermissions().can('BillingAccount', 'Read'));
}
